import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

addToListModalStyles.modal = {
    ...addToListModalStyles.modal,

    cssOverrides: {
        ...addToListModalStyles.modal?.cssOverrides,

        modalTitle: css`
            ${addToListModalStyles.modal?.cssOverrides?.modalTitle}

            padding: 7px 10px;

            ${mediaQueriesBP.minMD} {
                padding: 7px 10px 7px 22px;
            }
        `,

        modalContent: css`
            ${addToListModalStyles.modal?.cssOverrides?.modalContent}

            padding: 10px;
            overflow: visible;

            ${mediaQueriesBP.minMD} {
                padding: 20px;
            }
        `,

        modalBody: css`
            overflow: visible;
        `,
    },
};
addToListModalStyles.signInMessageText = {
    as: "p",
    css: css`
        a {
            display: inline-block;
            span {
                position: relative;
            }
        }
    `,
};
